import actionType from "../../ActionType";

const INITIAL_STATE = {
  accessToken: '',
};

export default function users(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionType.AUTHENTICATE_USER:
      return {
        accessToken: action.payload
      };
    default:
      return state
  }
}